import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const parallaxModule = () => {

    const elements = document.querySelectorAll('.js-parallax-y');

    elements.forEach(element => {

        const from = element.dataset.from || 0;
        const to = element.dataset.to || 0;

        gsap.set(element, {
            yPercent: from,
        });

        gsap.to(element, {
            yPercent: to,
            ease: 'none',
            scrollTrigger: {
                trigger: element,
                start: 'top 100%',
                end: 'bottom 0%',
                scrub: true
            }
        });

    });

};

export default parallaxModule;